import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=3e11639a"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationsBar: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/notifications/bar.vue').default})
